import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-item-view-catalog',
  templateUrl: './item-catalog.component.html',
  styleUrls: ['./item-catalog.component.scss']
})
export class ItemCatalogViewComponent implements OnInit, OnChanges {

  @Input() item: any;
  @Output() onClick: EventEmitter<any> = new EventEmitter<any>();

  constructor() { 
  }

  ngOnInit(): void {
    //this.item.color = this.getRandomColor();
  }

  ngOnChanges(changes: SimpleChanges): void {
    //this.item.color = this.getRandomColor();
  }

  public onClickItem(){
    this.onClick.emit({item: this.item});
  }

  public getRandomColor() {
    const colors = [
      '#c62828', // Rojo quemado
      //'#ad1457', // Rosa oscuro
      '#6a1b9a', // Morado profundo
      '#283593', // Azul fuerte
      '#1565c0', // Azul vibrante
      '#2e7d32', // Verde oscuro
      //'#ef6c00', // Naranja oscuro
      '#37474f', // Gris oscuro azulado
      '#5d4037', // Café fuerte
      '#455a64', // Azul grisáceo
    ];
    
    
    const randomColor = colors[Math.floor(Math.random() * colors.length)];
    //return randomColor;
    return `linear-gradient(135deg, ${randomColor} 0%, #ffffff20 100%)`;
  }
}
